export const environment = {
  production: false,
  apiUrl: 'https://test-api.cactusweb.io/api/v2/user',
  siteUrl: 'http://localhost:4200',
};
